import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'
const API_PATH = 'api/v2/admins/users'

const UsersApiV2 = {

  /**
   * Get list of users
   * Invoke `GET api/v2/admins/users
   * @param {object} tableState - ReactTable final state
   * @param {object} additionalFilters - A plain object to get customize filters outside `tableState`
   */
  get: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  },
  /**
   * Get list of phone codes
   * Invoke `GET api/v2/admins/users/phone_codes
   * @param {object} tableState - ReactTable final state
   * @param {object} additionalFilters - A plain object to get customize filters outside `tableState`
   */
  phone_codes: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path = `${API_PATH}/phone_codes`

    const response = axios.get(path, { params })
    return response
  },
  /**
   * Donwload list of mobile apps users as CSV
   * Invoke `GET api/v2/admins/users/csv
   */
  donwloadCsv: async () => {
    const path = `${API_PATH}/csv`

    const response = await axios.post(path, {})
    return response
  },
  // Get all `User.referrer`
  referrers: async () => {
    const path     = `${API_PATH}/referrers`
    const response = axios.get(path)

    return response
  },
  /**
   * Get one `User`
   * @param {object} id User id
   * @return {object} `User`
   */
  show: async (id) => {
    const path     = `${API_PATH}/${id}`
    const response = axios.get(path)
    return response
  },
  /**
   * Create User endpoint.
   * Invoke `POST api/v2/admins/users`
   * @param {object} user_values
   */
  create: async (params) => {
    const path     = API_PATH
    const response = axios.post(path, params)
    return response
  },
  /**
   * update `User` profile data
   * @param {number} id User id
   * @param {object} values values for User update
   * @return {object} `User`
   */
  update: async (id, values) => {
    const path = `${API_PATH}/${id}`

    const response = axios.patch(path, values)
    return response
  },
  /**
   * Send forgot password email to user
   * Invoke `POST identities/admins/passwords/forgot`
   * @param {string} email - user email
   */
  forgotPassword: async (email) => {
    const path = 'identities/admins/passwords/forgot'

    const body = {
      password: {
        email: email
      }
    }

    const response = axios.post(path, body)
    return response
  },
  /**
   * Get list of user addresses
   * Invoke `GET api/v2/admins/users/:id/addresses
   * @param {number} userId - userId number`
   */
  getAddresses: async ({ userId }) => {
    const path = `${API_PATH}/${userId}/addresses`

    const response = axios.get(path, { })
    return response
  }
}

export default UsersApiV2
